import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./screens/Home";
import Admin from "./screens/Admin";

require("dotenv").config();

class App extends React.Component {
  render() {
    return (
      <Router basename={process.env.REACT_APP_PUBLIC_PATH}>
        <Switch>
          <Route path="/admin/:section">
            <Admin />
          </Route>
          <Route path="/admin">
            <Admin />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </Router>
    );
  }
}
export default App;
